<template>
  <section class="mx-auto max-w-screen-xl py-8 lg:py-16">
    <!-- Desktop Version (3 items per slide) -->
    <swiper
      v-if="!isMobile"
      :navigation="true"
      :modules="modules"
      class="select-none rounded-xl"
      :loop="true"
    >
      <swiper-slide v-for="i in Math.ceil(images.length / 3)">
        <div class="grid grid-cols-3 gap-4">
          <div
            v-for="image in images.slice((i - 1) * 3, i * 3)"
            class="relative"
          >
            <NuxtImg
              :alt="image.alt"
              :src="$pb.files.getURL(image, image.image)"
              class="rounded-lg w-full aspect-square object-cover"
            />
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <!-- Mobile Version (1 item per slide) -->
    <swiper
      v-else
      :navigation="true"
      :modules="modules"
      class="select-none rounded-xl"
      :loop="true"
    >
      <swiper-slide v-for="image in images" :key="image.id" class="px-2">
        <div class="relative">
          <img
            :alt="image.alt"
            :src="$pb.files.getURL(image, image.image)"
            class="rounded-lg w-full aspect-square object-cover"
          />
        </div>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script setup lang="ts">
import { Navigation } from "swiper/modules";
import { onMounted, onUnmounted, ref } from "vue";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/vue";

const modules = [Navigation];
const isMobile = ref(false);

const images = ref<GalleryImage[]>([]);

const { fetchImages } = useGallery();
images.value = await fetchImages({ highlight: true });

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768;
};

onMounted(async () => {
  checkMobile();
  window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
});
</script>

<style>
:root {
  --swiper-theme-color: #fff !important;
}

.swiper-button-next,
.swiper-button-prev {
  width: 40px !important;
  height: 40px !important;
}

.swiper-button-next {
  right: 0 !important;
}

.swiper-button-prev {
  left: 0 !important;
}

@media (min-width: 768px) {
  .swiper-button-next {
    right: -5px !important;
  }

  .swiper-button-prev {
    left: -5px !important;
  }
}
</style>
